/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import { SVGProps } from 'react';

const ArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="ArrowUp">
    <path
      d="M9 3.828V16H7V3.828L1.636 9.192.222 7.778 8 0l7.778 7.778-1.414 1.414L9 3.828Z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowUp;
